import { Params } from '@angular/router';
import { DATE_BOUND_PATTERN, DateRangeTuple, formatDateBound, normalizeDateRange, parseRangeBound } from './date-range-filter.utils';

// URL grammar shared with the PrimeNG grids (paginated-url-sync):
// `filters=timestamp:dd.mm.yyyy[ hh:mm]-dd.mm.yyyy[ hh:mm]`, either bound optional.
const TIMESTAMP_SEGMENT_PREFIX = 'timestamp:';
const DATE_RANGE_RE = new RegExp(`^(${DATE_BOUND_PATTERN})?-(${DATE_BOUND_PATTERN})?$`);

/** Timestamp date-range read back from the `filters` query param, or null when absent/invalid. */
export function parseTimestampFilterFromUrl(queryParams: Params): DateRangeTuple | null {
  const raw: unknown = queryParams['filters'];
  if (typeof raw !== 'string') return null;
  const segment = raw.split(';').find(part => part.startsWith(TIMESTAMP_SEGMENT_PREFIX));
  if (!segment) return null;
  const value = segment.slice(TIMESTAMP_SEGMENT_PREFIX.length);

  const rangeMatch = value.match(DATE_RANGE_RE);
  if (rangeMatch) {
    return normalizeDateRange([parseRangeBound(rangeMatch[1], 'from'), parseRangeBound(rangeMatch[2], 'to')]);
  }
  // A lone bound: a day covers itself end to end, an instant stays a point in time.
  const from = parseRangeBound(value, 'from');
  return from ? [from, parseRangeBound(value, 'to')] : null;
}

/** `filters` query param value for a timestamp range — null clears the param. */
export function serializeTimestampFilterForUrl(range: unknown): string | null {
  const normalized = normalizeDateRange(range);
  if (!normalized) return null;
  const from = normalized[0] ? formatDateBound(normalized[0], 'from') : '';
  const to = normalized[1] ? formatDateBound(normalized[1], 'to') : '';
  return `${TIMESTAMP_SEGMENT_PREFIX}${from}-${to}`;
}
